import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "marginated-form p-fluid p-formgrid p-grid kn-flex p-m-2"
}
const _hoisted_2 = { class: "p-float-label" }
const _hoisted_3 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    id: "hierarchy-management-dimension-info-dialog",
    class: "p-fluid kn-dialog--toolbar--primary",
    visible: _ctx.visible,
    modal: true,
    closable: false,
    style: _ctx.hierarchyManagementDimensionsTableDescriptor.dialog.style
  }, {
    header: _withCtx(() => [
      _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary" }, {
        start: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('common.details')), 1)
        ]),
        _: 1
      })
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--primary",
        label: _ctx.$t('common.ok'),
        onClick: _ctx.close
      }, null, 8, ["label", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.selectedItem)
        ? (_openBlock(), _createBlock("form", _hoisted_1, [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.selectedItem, (item, index) => {
              return (_openBlock(), _createBlock("div", {
                class: "p-field p-col-12 p-md-6 p-lg-4",
                key: index
              }, [
                _createVNode("span", _hoisted_2, [
                  _createVNode(_component_InputText, {
                    class: "kn-material-input",
                    modelValue: item.value,
                    "onUpdate:modelValue": ($event: any) => (item.value = $event),
                    modelModifiers: { trim: true },
                    disabled: true
                  }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                  _createVNode("label", _hoisted_3, _toDisplayString(item.label), 1)
                ])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["visible", "style"]))
}